import React from "react";
import BudgetView from "./BudgetView";
import WeatherView from "./WeatherModal";
import useTripStore from "@/stores/tripBuilder/useTrip";
import { useWeather } from "@/hooks/useWeather";

/**
 * Widget component that displays budget and weather information for the selected location
 */
const BudgetWeatherWidget: React.FC = () => {
  const selectedLocation = useTripStore((state) => state.selectedLocation);
  const { data: weatherData, isLoading } = useWeather(selectedLocation);

  return (
    <div className="w-full h-full p-[1px] flex flex-row space-x-2 justify-between overflow-hidden">
      <BudgetView locationId={selectedLocation?.id || ""} />
      <WeatherView
        locationId={selectedLocation?.id || ""}
        name={selectedLocation?.name || ""}
        weatherData={weatherData || null}
        isLoading={isLoading}
      />
    </div>
  );
};

export default BudgetWeatherWidget;
